import { getState } from '@/services/mfa'
export const MFA = (to: any, from: any) => {
    const { authenticationResult, username } = getState()
    if (authenticationResult === undefined || username === undefined) {
        return { name: 'LoginView' }
    }
}
